module.exports = "/_next/static/images/ae5b967a0aebb687c6a4204ff73ca3a8-phone-icon.svg.webp";